import somaRouterPaths from './somaRouterPaths';

export default somaRouterPaths;
